import React, { useState, useEffect, useRef } from "react";
import { FaChevronLeft, FaChevronUp } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import axios from "axios";
import { withRouter } from "react-router-dom";
import { Config } from "../../Config";
import GSlider from "../../components/GSlider/GSlider";
import Skeleton from "react-loading-skeleton";
import MarketService from "../../components/MarketService/MarketService";
import "./MarketSingle.scss";
import "./Responsive.scss";
import "react-toastify/dist/ReactToastify.css";

const MarketSingle = (props) => {
  let productId;
  let productName;
  let pathLength = props.history.location.pathname.split("/");
  if (!pathLength[3]) {
    props.history.push("/404");
  } else {
    productName = pathLength[3];
  }

  if (!pathLength[2]) {
    props.history.push("/404");
  } else {
    productId = pathLength[2];
  }
  const descRef = useRef(null);
  const showMoreRef = useRef(null);
  const [product, setProduct] = useState("");
  const [preloader, setPreloader] = useState(true);
  const [showMoreDescription, setShowMoreDescription] = useState(false);
  const [resetPage, setResetPage] = useState({ state: false, count: 0 });
  const user = useSelector((state) => state.user);

  useEffect(async () => {
    Config.pageUp();
    await getSingleProduct(productId);
  }, []);

  useEffect(() => {
    if (!preloader) {
      // console.log(descRef.current.clientHeight);
      if (descRef.current.clientHeight > 200) {
        descRef.current.style.maxHeight = "200px";
        showMoreRef.current.style.display = "block";
      } else {
        showMoreRef.current.style.display = "none";
        descRef.current.style.maxHeight = "unset";
      }
    }
  }, [preloader]);

  const getSingleProduct = async (id) => {
    if (resetPage.count == 0) {
      setPreloader(true);
    }
    axios
      .get(
        `/Api/WelfareServiceCenters/Get?id=${id}`,
        user[0]?.token && {
          headers: {
            Authorization: `Bearer ${user[0]?.token}`,
          },
        }
      )
      .then((result) => {
        console.log("result.data", result.data.data);
        setProduct(result.data.data);
        setResetPage({ state: resetPage.state, count: resetPage.count + 1 });
        setPreloader(false);
      })
      .catch((error) => {
        setPreloader(false);
        props.history.push("/404");
        // console.log("error", error);
      });
  };

  const showMoreDesc = (e) => {
    // let desc = document.querySelector(".productLeftBox .description");
    if (descRef.current.clientHeight <= 200) {
      setShowMoreDescription(true);
      descRef.current.style.maxHeight = "100%";
    } else {
      setShowMoreDescription(false);
      descRef.current.style.maxHeight = "200px";
    }
  };
  return (
    <section className="singleProductWrapper mobile">
      <Helmet>
        <title>{product?.name ? `${Config.helmetTitle} | ${`${product?.name}`}` : `${Config.helmetTitle}`}</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      <div className="productContents">
        <div className="desktop">
          <div className="stickyHelper market">
            <div className="productImagesBox">
              {!product || !product.image ? (
                <Skeleton
                  containerClassName="imageGalleryWrapper"
                  className="skeleton zoomSkeleton"
                  // style={{ minHeight: "500px" }}
                  highlightColor={Config.skeletonHighlightColor}
                />
              ) : (
                <div className="imageGalleryWrapper">
                  <GSlider images={[`${product.image}`]} />
                </div>
              )}
              {!product || !product.name ? (
                <Skeleton
                  containerClassName="title"
                  className="skeleton"
                  highlightColor={Config.skeletonHighlightColor}
                  style={{ minHeight: "50px" }}
                />
              ) : (
                <p className="title">{product && product.name}</p>
              )}
              {/* {!product ||
                (!product.description && (
                  <Skeleton
                    containerClassName="description"
                    className="skeleton"
                    style={{ minHeight: "35px", width: "50%" }}
                    highlightColor={Config.skeletonHighlightColor}
                  />
                ))} */}
              <p className="description" ref={descRef}>
                {product && product.description}
              </p>

              <span className="showDescMore" ref={showMoreRef} onClick={(e) => showMoreDesc(e)}>
                {showMoreDescription ? (
                  <span>
                    بستن <FaChevronUp />
                  </span>
                ) : (
                  <span>
                    مشاهده بیشتر <FaChevronLeft />
                  </span>
                )}
              </span>
            </div>
          </div>
          <div className="productLeftBox market">
            <div className="topTitle">
              <MarketService
                maxWidth={false}
                address={product.address}
                telephone={product.telephone}
                destination={product.destination}
                origin={product.origin}
                lat={product.lat}
                long={product.lng}
              />
            </div>
          </div>
          <div className="optionWrapper">
            {product.options !== undefined && product.options.length > 0 && (
              <div className="options">
                <p className="title">ویژگی ها</p>
                {product.options &&
                  product.options.map((item, index) => {
                    return (
                      <div className="optionItems" key={index}>
                        <p className="optionItem">
                          <span className="optionKey">{item.name} :</span>
                          <span className="optionValue">{item.value}</span>
                        </p>
                      </div>
                    );
                  })}
              </div>
            )}
          </div>
          {/* <div className="comments">
            <p className="title">
              <FaCommentAlt /> دیدگاه کاربران ({comments.length})
            </p>
            {user.length > 0 ? (
              <button className="showCommentModal" onClick={(e) => showCommentModal(e)}>
                ارسال دیدگاه
              </button>
            ) : (
              <p className="loginWarning">برای ارسال دیدگاه باید وارد حساب کاربری خود شوید</p>
            )}
            <Comments commentData={comments} />
          </div> */}
        </div>
      </div>
      {/* {commentModal && (
        <CommentModal
          show={commentModal}
          showSpinner={showSpinner}
          submitHandler={commentSubmitHandler}
          hideCommentModal={hideCommentModal}
        />
      )} */}
    </section>
  );
};

export default React.memo(withRouter(MarketSingle));
